// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./ASSETS/FONTS/Silka-Regular-&-Italic-Webfont/silka-regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./ASSETS/FONTS/Silka-Regular-&-Italic-Webfont/silka-regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./ASSETS/FONTS/Silka-Regular-&-Italic-Webfont/silka-regularitalic-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./ASSETS/FONTS/Silka-Regular-&-Italic-Webfont/silka-regularitalic-webfont.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Silka";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
      format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___})
      format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Silka";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
      format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___})
      format("woff");
  font-weight: normal;
  font-style: italic;
}
:root {
  /* Brand yellow family - single source of truth. CSS Modules can read
     these since custom properties inherit through the whole document. */
  --kur-yellow: #fff000;
  --kur-yellow-soft: #fde63b;
  --kur-gold: #ffd700;
  --kur-gold-hover: #e0b300;
  --kur-amber: #f8b400;
}

body {
  user-select: none;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE/Edge */
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB;;;oBAGkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB;;;oBAGkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE;wEACsE;EACtE,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB,EAAE,WAAW;EACtC,sBAAsB,EAAE,YAAY;EACpC,qBAAqB,EAAE,YAAY;AACrC","sourcesContent":["@font-face {\n  font-family: \"Silka\";\n  src: url(\"./ASSETS/FONTS/Silka-Regular-&-Italic-Webfont/silka-regular-webfont.woff2\")\n      format(\"woff2\"),\n    url(\"./ASSETS/FONTS/Silka-Regular-&-Italic-Webfont/silka-regular-webfont.woff\")\n      format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Silka\";\n  src: url(\"./ASSETS/FONTS/Silka-Regular-&-Italic-Webfont/silka-regularitalic-webfont.woff2\")\n      format(\"woff2\"),\n    url(\"./ASSETS/FONTS/Silka-Regular-&-Italic-Webfont/silka-regularitalic-webfont.woff\")\n      format(\"woff\");\n  font-weight: normal;\n  font-style: italic;\n}\n:root {\n  /* Brand yellow family - single source of truth. CSS Modules can read\n     these since custom properties inherit through the whole document. */\n  --kur-yellow: #fff000;\n  --kur-yellow-soft: #fde63b;\n  --kur-gold: #ffd700;\n  --kur-gold-hover: #e0b300;\n  --kur-amber: #f8b400;\n}\n\nbody {\n  user-select: none;\n  -webkit-user-select: none; /* Safari */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* IE/Edge */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
